let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("aksCE")).then(() => parcelRequire('8eArQ'));